import { ArrowUpRight } from "lucide-react";
import { FAQ_ITEMS } from "@/data/content";
import { SectionLabel, Reveal } from "@/components/site/primitives";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="mx-auto max-w-[1400px] px-5 md:px-10 py-28 md:py-44"
    >
      <SectionLabel index="[ 09 ]" testId="faq-label">
        Investor FAQ
      </SectionLabel>

      <Reveal>
        <h2 className="font-grotesk font-black uppercase tracking-tighter text-4xl md:text-6xl text-epic-text leading-[0.9] max-w-4xl mb-14 md:mb-20">
          Straight answers.
        </h2>
      </Reveal>

      <Reveal delay={0.1} className="max-w-3xl">
        <Accordion type="single" collapsible>
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`faq-${i}`}
              className="border-epic-line"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="font-grotesk font-bold uppercase tracking-tight text-base md:text-lg text-epic-text hover:no-underline hover:text-epic-accent py-6 transition-colors duration-200"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="font-mono text-sm text-epic-sub leading-relaxed"
              >
                {item.a}
                {item.linkHref && (
                  <a
                    href={item.linkHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`faq-link-${i}`}
                    className="mt-3 inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] text-epic-accent transition-colors duration-200 hover:text-epic-text"
                  >
                    {item.linkText}
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </a>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
};
